import { gql } from 'graphql-request';

import type { RequestDocument } from 'graphql-request';

export const ALL_RELEASES_QUERY: RequestDocument = gql`
  query allReleases($first: IntType, $skip: IntType) {
    allReleasesModels(first: $first, skip: $skip, orderBy: _createdAt_DESC) {
      id
      releaseName
      description
      video {
        id
        title
        videoFilePrimary {
          url
          video {
            thumbnailUrl
            muxPlaybackId
            mp4Url
          }
        }
      }
      image {
        url
        width
        height
        title
      }
      _createdAt
    }
    _allReleasesModelsMeta {
      count
    }
  }
`;

export const LATEST_RELEASE_QUERY: RequestDocument = gql`
  query latestRelease {
    allReleasesModels(first: 1, orderBy: _createdAt_DESC) {
      id
      releaseName
      description
      video {
        id
        title
        videoFilePrimary {
          url
          video {
            thumbnailUrl
            muxPlaybackId
            mp4Url
          }
        }
      }
      image {
        url
        width
        height
        title
      }
      _createdAt
    }
  }
`;
